import {z} from 'zod';
import {CreateUserRequest} from '../api/generated/index.defs.ts';
import {mapNullToUndefined, nonEmptyString} from '../utils/zod.ts';
import {RolesSchema, UserTitlesSchema} from '../api/generated/enums.ts';

export const createUserSchema = z.object({
  inactive: z.boolean(),
  partnerSiteIds: z.array(z.number()).optional(),
  emailAddress: nonEmptyString(),
  firstName: nonEmptyString(),
  lastName: nonEmptyString(),
  role: RolesSchema,
  title: mapNullToUndefined(UserTitlesSchema.optional()),
  claims: mapNullToUndefined(z.array(z.string()).optional()),
}) satisfies z.Schema<CreateUserRequest>;
export type CreateUserSchema = z.TypeOf<typeof createUserSchema>;